module.exports = __webpack_public_path__ + "static/media/17.f5d936e7.png";